// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accent":"_2evdeZ","accent-small":"_1G_Rbn"};